import { render } from "./ErrorMessage.vue.js?vue&type=template&id=f28b65fd!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorMessage.vue?vue&type=template&id=f28b65fd"
import script from "./ErrorMessage.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMessage.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorMessage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/dashboard/components/common/ErrorMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f28b65fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f28b65fd', __exports__)) {
    api.reload('f28b65fd', __exports__)
  }
  
  module.hot.accept("./ErrorMessage.vue.js?vue&type=template&id=f28b65fd!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorMessage.vue?vue&type=template&id=f28b65fd", () => {
    api.rerender('f28b65fd', render)
  })

}


export default __exports__